import axios from 'axios';
import { createFormData } from '../lib/create-form-data';
import { queue } from '@lib/queue-with-delay';
import { IS_LOCAL, IS_DEVELOPMENT, IS_PRODUCTION } from '@constants';

if (IS_PRODUCTION) {
  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
} else if (IS_LOCAL) {
  axios.defaults.withCredentials = true;
}

// todo для локальных json POST отдает 404
const setMethod = (method) => (method === 'POST' && process.env.NODE_ENV === 'development' ? 'GET' : method);

export const api = {
  getProjects: async (folderId, teamId, offset, count) =>
    request({
      url:
        withLocal('/projects/', `/api/${folderId ? 'projects-folder' : 'projects'}.json`) +
        withParams({
          folder_id: folderId,
          team_id: teamId,
          offset: offset,
          count: count,
        }),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  createProject: async (currentFolderId, teamId) =>
    request({
      url:
        withLocal('/projects/add/', '/api/createProject.json') +
        withParams({
          team_id: teamId,
          folder_id: currentFolderId,
        }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  deleteProject: async (projectId, teamId) =>
    request({
      url:
        withLocal('/projects/delete/', '/api/createFolder.json') +
        withParams({
          'id[]': projectId,
          'team_id': teamId,
        }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  renameProject: async (projectId, name, teamId) =>
    request({
      url:
        withLocal('/projects/edit/', '/api/createFolder.json') +
        withParams({
          id: projectId,
          name: name,
          team_id: teamId,
        }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  moveProject: async (projectId, distFolderId, teamId) =>
    request({
      url:
        withLocal('/api/moveprojects/', '/api/createFolder.json') +
        withParams({
          'project_id[]': projectId,
          'folder_id': distFolderId,
          'team_id': teamId,
        }),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  moveProjectTeam: async (projectId, distFolderId, teamId) =>
    request({
      url:
        withLocal('/projects/move/', '/api/createFolder.json') +
        withParams({
          'project_id[]': projectId,
          'folder_id': distFolderId,
          'team_id': teamId,
        }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  duplicateProject: async (projectId, folderId, teamId) =>
    request({
      url:
        withLocal('/projects/copy/', '/api/duplicate.json') +
        withParams({
          'id[]': projectId,
          'folder_id': folderId,
          'team_id': teamId,
          'widget_popgo': 1,
          'content_bg': 1,
          'content_panorama': 1,
        }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  createFolder: async (parentId, name, teamId) =>
    request({
      url:
        withLocal('/api/createfolder/', '/api/createFolder.json') +
        withParams({
          parent_id: parentId,
          name: name,
          team_id: teamId,
        }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  deleteFolder: async (folderId, teamId) =>
    request({
      url:
        withLocal('/api/deletefolder/', '/api/createFolder.json') +
        withParams({
          folder_id: folderId,
          team_id: teamId,
        }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  renameFolder: async (folderId, name, teamId) =>
    request({
      url:
        withLocal('/api/renamefolder/', '/api/createFolder.json') +
        withParams({
          folder_id: folderId,
          name: name,
          team_id: teamId,
        }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  moveFolder: async (folderId, parentId, teamId) =>
    request({
      url:
        withLocal('/api/movefolder/', '/api/createFolder.json') +
        withParams({
          folder_id: folderId,
          parent_id: parentId,
          team_id: teamId,
        }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  getGoods: async (teamId) =>
    request({
      url:
        withLocal('/users/getgoods/', '/api/goods.json') +
        withParams({
          team_id: teamId,
        }),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  getUser: async () =>
    request({
      url: withLocal('/users/profile/', '/api/users.json'),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  getHistoryPayment: async (offset, count) =>
    request({
      url:
        withLocal('/users/historypayment/', '/api/history-payment.json') +
        withParams({
          offset: offset,
          count: count,
        }),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  getNotifications: async () =>
    request({
      url: withLocal('/users/notifications/', '/api/notifications.json'),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  editNotifications: async (notifications) =>
    request({
      url:
        withLocal('/users/notificationsedit/', '/api/notifications.json') +
        withParams({
          'notifications[]': notifications,
        }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  getTextures: async () =>
    request({
      url: withLocal('/api/textures.json'),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  getTeams: async () =>
    request({
      url: withLocal('/teams/', '/api/teams.json'),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  getMembers: async (teamId) =>
    request({
      url:
        withLocal('/teams/members', '/api/members.json') +
        withParams({
          team_id: teamId,
        }),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  addMember: async (teamId, email) =>
    request({
      url:
        withLocal('/teams/addmember', '/api/teams.json') +
        withParams({
          team_id: teamId,
          email: email,
        }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  removeMember: async (teamId, id) =>
    request({
      url:
        withLocal('/teams/removemember', '/api/teams.json') +
        withParams({
          team_id: teamId,
          id: id,
        }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  blockMember: async (teamId, id) =>
    request({
      url:
        withLocal('/teams/blockmember', '/api/teams.json') +
        withParams({
          team_id: teamId,
          id: id,
        }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  unblockMebmer: async (teamId, id) =>
    request({
      url:
        withLocal('/teams/unblockmember', '/api/teams.json') +
        withParams({
          team_id: teamId,
          id: id,
        }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  editTeam: async (data) =>
    request({
      url: withLocal('/teams/edit', '/api/teams.json'),
      method: 'POST',
      data: createFormData(data),
      headers: {
        'content-Type': 'multipart/form-data',
      },
      credentials: 'same-origin',
    }),
  deleteTeam: async () =>
    request({
      url: withLocal('/teams/delete?confirm=1', '/api/teams.json'),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  editUser: async (data) =>
    request({
      url: withLocal('/users/edit', '/api/teams.json'),
      method: setMethod('POST'),
      data: createFormData(data),
      headers: {
        'content-Type': 'multipart/form-data',
      },
      credentials: 'same-origin',
    }),
  deleteUser: async () =>
    request({
      url: withLocal('/users/delete?confirm=1', '/api/teams.json'),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  changePassword: async ({ password, newPassword, newPasswordRepeat }) =>
    request({
      url:
        withLocal('/users/changepassword', '/api/teams.json') +
        withParams({
          password: password,
          new_password: newPassword,
          new_password_repeat: newPasswordRepeat,
        }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  getGroups: async () =>
    request({
      url: withLocal('/groups/', '/api/groups.json'),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  getScreenshots: async (projectId, teamId) =>
    request({
      url:
        withLocal('/projects/delete/', '/api/get-screenshots.json') +
        withParams({
          id: projectId,
          team_id: teamId,
        }),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  getTansactionsHistory: async (teamId) =>
    request({
      url:
        withLocal('/users/payments', '/api/transactions-history.json') +
        withParams({
          team_id: teamId,
        }),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  sendInvoiceRequest: async (userId, email, msg, currentTeam) =>
    request({
      url:
        withLocal('/projects/widgetMultiInvoiceRequest/', '/api/transactions-history.json') +
        withParams({
          email: email,
          msg: msg,
          id: userId,
          team_id: currentTeam,
        }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  importProjects: async (link, folderId, teamId) =>
    request({
      url:
        withLocal('/ru/projects/imports/', '/api/transactions-history.json') +
        withParams({
          link: link,
          folder_id: folderId,
          team_id: teamId,
        }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  getPricing: async (teamId) =>
    request({
      url:
        withLocal('/store/pricing', '/api/pricing.json') +
        withParams({
          team_id: teamId,
        }),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  requestWithUrl: async (url, data = {}) =>
    request({
      url,
      data: createFormData(data),
      method: IS_DEVELOPMENT ? 'GET' : 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  setMultiauthPassword: async (url, data) =>
    request({
      url,
      method: 'POST',
      data: createFormData(data),
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  multiCreate: async (selected, teamId) =>
    request({
      url:
        withLocal('/projects/widgetMultiCreate', '/api/multiwidget-create.json') +
        withParams({ ...selected, team_id: teamId }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  multiDelete: async (id, teamId) =>
    request({
      url:
        withLocal('/projects/widgetMultiDelete', '/api/multiwidget-create.json') + withParams({ id, team_id: teamId }),
      method: 'POST',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  getCards: async () =>
    request({
      url: withLocal('/users/binding/', '/api/binding.json'),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  addCard: async (data) =>
    request({
      url: withLocal('/store/binding/', '/api/addCard.json'),
      method: 'POST',
      data: createFormData(data),
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  setDefaultCard: async (data) =>
    request({
      url: withLocal('/users/setdefaultbinding/', '/api/addCard.json'),
      method: 'POST',
      data: createFormData(data),
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  removeCard: async (data) =>
    request({
      url: withLocal('/users/unbinding/', '/api/addCard.json'),
      method: 'POST',
      data: createFormData(data),
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  getPaymentMethods: async () =>
    request({
      url: withLocal('/store/paymentmethods/', '/api/paymentmethods.json'),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  getCountries: async () =>
    request({
      url: withLocal('/store/countries/', '/api/countries.json'),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  changeTariff: async (data) => {
    const url = data.team_id ? '/teams/tariffchange/' : '/users/tariffchange/';

    return await request({
      url: withLocal(url, '/api/tariff-change.json') + withParams(data),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    });
  },
  getAutoPay: async (team_id) => {
    const url = team_id ? '/teams/autopayment/' : '/users/autopayment/';

    return await request({
      url: withLocal(url, '/api/autopayment/status.json') + withParams({ team_id }),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    });
  },
  cancelAutoPay: async (team_id) => {
    const url = team_id ? '/teams/autopaymentcancel/' : '/users/autopaymentcancel/';

    return await request({
      url: withLocal(url, '/api/autopayment/cancel.json') + withParams({ team_id }),
      method: 'GET',
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    });
  },

  payTariff: async (data) => {
    const url = data.team_id ? '/teams/dotariffchange/' : '/users/dotariffchange/';

    return await request({
      url: withLocal(url, '/api/pay-tariff.json'),
      method: setMethod('POST'),
      data: createFormData(data),
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    });
  },
  storePay: async (isRedirect, body, products) => {
    const local = '/api/store-pay.json';
    const params = withParams(body) + products;
    const url = isRedirect ? withLocal(isRedirect, local) : withLocal('/store/pay', local) + params;

    return await request({
      url,
      method: setMethod('POST'),
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    });
  },
  checkStatusPay: async (data) =>
    request({
      url: withLocal('/store/check/', '/api/check-status-pay.json'),
      method: setMethod('POST'),
      data: createFormData(data),
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  userPromo: async (data) =>
    request({
      url: withLocal('/store/usepromo/', '/api/promo/success.json'),
      method: setMethod('POST'),
      data: createFormData(data),
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  confirmEmail: async (data) =>
    request({
      url: withLocal('/users/confirmation', '/api/confirm-email.json'),
      method: setMethod('POST'),
      data: createFormData(data),
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  resendConfirmEmail: async () =>
    request({
      url: withLocal('/users/confirm', '/api/confirm-email.json'),
      method: setMethod('GET'),
      headers: {
        'content-Type': 'text/plain',
      },
      credentials: 'same-origin',
    }),
  getSeamlessAuthToken: async () =>
    request({
      url: withLocal('/users/getseamlessauthenticationtoken/', '/api/seamlesstoken.json'),
      method: setMethod('GET'),
      headers: {
        'content-Type': 'application/json',
      },
    }),
};

const withParams = (params) => {
  if (!params) return '';

  let paramsString = '';
  let isFirst = true;

  const createParams = (i, item) => {
    paramsString += isFirst ? '?' : '&';
    paramsString += i + '=' + item;

    isFirst = false;
  };

  for (let i in params) {
    if (typeof params[i] === 'undefined' || params[i] === null || params[i] === '') {
      if (process.env.NODE_ENV !== 'production') {
        console.warn(`Missing ${i} value in request`); // eslint-disable-line
      }

      continue;
    }

    if (typeof params[i] === 'object') {
      params[i].forEach((item) => {
        createParams(i, item);
      });
    } else {
      createParams(i, params[i]);
    }
  }

  return paramsString;
};

const request = async (req) => {
  if ((IS_PRODUCTION || IS_LOCAL) && window.location.host !== 'pop') {
    return await axios(req);
  }

  return await queue(() => axios(req), 500); // Не понятно зачем?
};

const withLocal = (url, local) => {
  if (IS_PRODUCTION) {
    return url;
  } else if (IS_LOCAL) {
    return url.indexOf('pp.ksdev.ru') === -1 ? `https://pp.ksdev.ru${url}` : url;
  } else {
    return local ? local : url;
  }
};
